<div class="truck-capacity-indication">
   <button type="button" class="btn btn-primary" [ngClass]="{'active': visible}" (click)="toggle()">
      {{'production.trucks'|translate}} {{'production.capacity'|translate|lowercase}} {{'ui.indication'|translate|lowercase}} <i class="fa fa-caret-down"></i>
   </button>
   <div class="panel-container clearfix">
      <div [hidden]="!visible" class="jbm-overlay-panel panel">
         <div class="header"></div>
         <div id="truck-capacity-chart" class="truck-capacity-chart"></div>
         <div class="footer">
            <span class="hour-label">{{'datetime.hours'|translate}}</span>
            <button type="button" class="btn btn-sm btn-secondary float-end" (click)="toggle()">{{'ui.close'|translate}} </button>
         </div>
      </div>
   </div>
</div>
